module.exports = __webpack_public_path__ + "img/certificate.92bdb61b.jpeg";